/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.verification.revokeVerifications'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  uris: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' }), {
    maxLength: 100,
  }),
  revokeReason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 1000 }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  revokedVerifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
  failedRevocations: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<RevokeError>((() => revokeError) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Revoke previously granted verifications in batches of up to 100. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Error object for failed revocations */
type RevokeError = {
  $type?: 'tools.ozone.verification.revokeVerifications#revokeError'

  /**
   * The AT-URI of the verification record that failed to revoke.
   */
  uri: l.AtUriString

  /**
   * Description of the error that occurred during revocation.
   */
  error: string
}

export type { RevokeError }

/** Error object for failed revocations */
const revokeError = /*#__PURE__*/ l.typedObject<RevokeError>(
  $nsid,
  'revokeError',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    error: /*#__PURE__*/ l.string(),
  }),
)

export { revokeError }
